<template>
  <div v-if="element" :class="`${element.compData.type}-theme-${element.compData.styleId}`"
    :style="{...getStyles(element.compData.styles),
    width: element.width + 'px',
    height: element.height + 'px',}">
    <Select v-model="element.compData.activeIndex" @on-change="handleClick" :class="[element.compData.selectionBorder =='true' ? 'selectionBorder' : '', element.compData.dropdownBorder =='true' ? 'dropdownBorder' : '']">
        <Option v-for="(item, index) in element.compData.menus" :value="index" :key="item.id">{{ item.name }}</Option>
    </Select>
  </div>
</template>

<script>
// iview
import {
  Select,
  Option
} from 'view-design';
import 'view-design/dist/styles/iview.css'

export default {
  name: 'CompSelect',
  props: {
    element: {
      type: Object,
      default: null,
      require: true
    }
  },
  components: {
    Select,
    Option
  },
  data: () => {
    return {
      loading: true
    }
  },
  computed: {
    plugin: function() {
      return this.$getPlugin(this.element.id)
    }
  },
  mounted () {
    setTimeout(() => {
      this.loading = false
    }, 1234)
    this.element.compData.activeIndex = this.element.compData.defaultActiveIndex
    this.$nextTick(() => {
      this.$blueMap.trigger({
        nodeType: 'plugin',
        pluginId: this.element.id,
        dataKey: 'onmounted',
        eventData: {
          value: this.element.compData.menus[this.element.compData.activeIndex],
          data: this.plugin,
          event: null
        }
      })
    })
  },
  methods: {
    handleClick (activeIndex) {
      const item = this.element.compData.menus[activeIndex] || null
      item && this.$blueMap.trigger({
        nodeType: 'plugin',
        pluginId: this.plugin.id,
        dataKey: 'onclick',
        eventData: {
          value: item,
          data: this.plugin,
          event: null
        }
      })
    },
    getStyles (styles) {
      if (!styles) return
      const res = {}
      Object.keys(styles).forEach((item) => {
        res[`--${item}`] = (typeof styles[item] === 'number') ? styles[item] + 'px' : styles[item]
      })
      return res
    }
  }
}
</script>

<style lang='less' scoped>
  /deep/ .ivu-select{
    position: relative;
    height: var(--selectionHeight);
  }
  /deep/ .ivu-select-visible .ivu-select-selection{
    border-color:#000;
  }
  /deep/ .ivu-select-single .ivu-select-selection{
    height: var(--selectionHeight);
    color: white;
    background-color: var(--selectionBgColor);
    border: none;
  }
  /deep/ .ivu-select-arrow{
      font-size: var(--arrowSize);
      color: var(--arrowColor);
  }
  /deep/ .ivu-select-dropdown{
    background-color: var(--dropdownBgColor);
    top: var(--selectionHeight) !important;
    margin-top: 0;
    max-height: none;
  }
  /deep/ .ivu-select-item{
    color: var(--dropdownColor);
    font-size: calc(var(--fontSize) - 4px) !important;
    font-family: var(--fontFamily) !important;
    line-height: calc(var(--selectionHeight) - 15px);
    &:hover{
      background-color: var(--dropdownHoverBgColor);
      color: var(--dropdownHoverColor);
    }
  }
  /deep/ .ivu-select-item-focus{
    background: #2e2e2e;
  }
/deep/ .ivu-select-placeholder,
/deep/ .ivu-select-selected-value{
  height: calc(var(--selectionHeight) - var(--selectionBorderWidth) * 2) !important;
  line-height: calc(var(--selectionHeight) - var(--selectionBorderWidth) * 2) !important;
  font-size: var(--fontSize) !important;
  font-family: var(--fontFamily) !important;
  color: var(--fontColor) !important;
}
  /deep/ .selectionBorder.ivu-select-single .ivu-select-selection{
    border: var(--selectionBorderWidth) solid var(--selectionBorderColor) !important;
    border-radius: var(--selectionBorderRadius) !important;
  }
  /deep/ .ivu-select-placeholder,
  /deep/ .ivu-select-selected-value{
    height: calc(var(--selectionHeight) - var(--selectionBorderWidth) * 2) !important;
    line-height: calc(var(--selectionHeight) - var(--selectionBorderWidth) * 2) !important;
  }
.dropdownBorder{
  /deep/ .ivu-select-dropdown{
    border: var(--dropdownBorderWidth) solid var(--dropdownBorderColor);
    border-radius: var(--dropdownBorderRadius);
  }
}
</style>
